var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEarmarkCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1136_138442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3864 16.3822C22.58 16.187 22.6888 15.9222 22.6888 15.6461C22.6888 15.37 22.58 15.1052 22.3864 14.9099C22.1927 14.7147 21.9301 14.605 21.6562 14.605C21.3824 14.605 21.1198 14.7147 20.9261 14.9099L15.4688 20.4142L13.1051 18.0291C12.9115 17.8339 12.6489 17.7242 12.375 17.7242C12.1012 17.7242 11.8385 17.8339 11.6449 18.0291C11.4512 18.2243 11.3424 18.4891 11.3424 18.7652C11.3424 19.0413 11.4512 19.3061 11.6449 19.5014L14.7386 22.6205C14.8344 22.7174 14.9482 22.7942 15.0735 22.8466C15.1988 22.899 15.3331 22.926 15.4688 22.926C15.6044 22.926 15.7387 22.899 15.864 22.8466C15.9893 22.7942 16.1031 22.7174 16.1989 22.6205L22.3864 16.3822Z",
    fill: "#EC6726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.875 29.1625V9.40771L19.5938 0.0501709H8.25C7.15598 0.0501709 6.10677 0.48834 5.33318 1.26829C4.5596 2.04823 4.125 3.10607 4.125 4.20907V29.1625C4.125 30.2655 4.5596 31.3233 5.33318 32.1033C6.10677 32.8832 7.15598 33.3214 8.25 33.3214H24.75C25.844 33.3214 26.8932 32.8832 27.6668 32.1033C28.4404 31.3233 28.875 30.2655 28.875 29.1625ZM19.5938 6.28853C19.5938 7.11578 19.9197 7.90916 20.4999 8.49412C21.0801 9.07908 21.867 9.40771 22.6875 9.40771H26.8125V29.1625C26.8125 29.714 26.5952 30.2429 26.2084 30.6329C25.8216 31.0229 25.297 31.242 24.75 31.242H8.25C7.70299 31.242 7.17839 31.0229 6.79159 30.6329C6.4048 30.2429 6.1875 29.714 6.1875 29.1625V4.20907C6.1875 3.65757 6.4048 3.12865 6.79159 2.73868C7.17839 2.34871 7.70299 2.12962 8.25 2.12962H19.5938V6.28853Z",
    fill: "#EC6726"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_138442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33.2712,
    fill: "white",
    transform: "translate(0 0.0501709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEarmarkCheck);
export default __webpack_public_path__ + "static/media/file-earmark-check.8107c66ed4983d6f00c0f7d9eb126b96.svg";
export { ForwardRef as ReactComponent };